import React, { useMemo } from 'react';
import Link from 'next/link';
import getPreviewText from '@tmap/mmm-core/slate/getPreviewText';
import { toKey, types } from '@tmap/mmm-core/entityKey';
import { Box } from '@tmap/mmm-style-guide/src/Box';
import { ImageListItem, ImageListItemBar } from '@tmap/mmm-style-guide/src/ImageList';
import { styled } from '@tmap/mmm-style-guide/src/styled';

import ContributionMedia from './contributionMedia';
import useImpressions, { ImpressionTracker } from '../../hooks/useImpressions';

const StyledImageListItem = styled(ImageListItem)(({ theme }) => ({
  video: {
    paddingBottom: theme.spacing(6),
  },
  '.video-box': {
    borderRadius: '8px',
    paddingTop: '60%',
  },
  img: {
    borderRadius: '8px',
    objectFit: 'cover',
  },
  '.react-player__preview': {
    borderRadius: '8px',
  },
  '.MuiImageListItemBar-root': {
    borderRadius: '0 0 8px 8px',
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(5),
    height: '100%',
    width: '100%',
  },
}));

const createMediaCaption = (post) => {
  const actualPreview = getPreviewText(post.content, { maxLength: 50 });
  if (!actualPreview.length) {
    return `Gallery by ${post.author?.firstName} ${post.author?.lastName}`;
  }
  const longerText = getPreviewText(post.content, { maxLength: 60 });
  return `${actualPreview}${longerText.length > 50 ? '...' : ''}`;
};

function MediaLink({ post }) {
  return (
    <Link href={`/c/${post.slug}`}>
      <Box height={304}>
        <ContributionMedia media={post.media[0]} mode='hero' previewOnly />
        <ImageListItemBar
          title={createMediaCaption(post)}
        />
      </Box>
    </Link>
  );
}

function PinnedPost(props) {
  const {
    cols,
    rows,
    post,
    placementId,
    pageId,
  } = props;
  const impressionMeta = useMemo(() => ({ pageId }), [pageId]);
  const { trackView, trackClick } = useImpressions(
    toKey(types.CONTRIBUTION, post._id),
    placementId,
    impressionMeta,
  );

  return (
    <StyledImageListItem cols={cols} rows={rows}>
      <ImpressionTracker trackView={trackView} trackClick={trackClick}>
        <MediaLink post={post} />
      </ImpressionTracker>
    </StyledImageListItem>
  );
}

export default PinnedPost;
